/**
 * 将 FastAPI / axios 错误解析为用户可读文案（优先使用 detail）
 */
export function getApiErrorMessage(err, fallback = '操作失败') {
  if (err == null || err === false) return fallback
  if (typeof err === 'string') return err || fallback

  const d = err.detail
  if (typeof d === 'string' && d.trim()) return d.trim()
  if (Array.isArray(d)) {
    const parts = d
      .map((x) => (x && (x.msg != null ? String(x.msg) : '')) || '')
      .filter(Boolean)
    if (parts.length) return parts.join('；')
  }

  if (err.response?.data) {
    return getApiErrorMessage(err.response.data, fallback)
  }
  if (typeof err.message === 'string' && err.message && err.message !== 'Error') {
    return err.message
  }
  return fallback
}
